import type { SxProps, Theme } from '@mui/material';

export const membershipsLayoutSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const membershipsLayoutBlockContentSx: SxProps<Theme> = {
  padding: 0,
  minHeight: 0,
};

export const previewBodySecondarySx: SxProps<Theme> = {
  opacity: 0.9,
};

export const previewBodyTertiarySx: SxProps<Theme> = {
  opacity: 0.7,
  mt: 2,
};

export const saveButtonSx: SxProps<Theme> = {
  py: 1.5,
  textTransform: 'none',
  fontWeight: 500,
};

export const configLoadingSkeletonSx: SxProps<Theme> = {
  width: '100%',
  p: 2,
};

export const membershipsBlockContentProps = {
  sx: membershipsLayoutBlockContentSx,
};

// Holds its height when the action buttons are absent on the landing page surface.
export const configPanelTitleRowSx: SxProps<Theme> = {
  minHeight: (theme) => theme.spacing(4),
};

export const panelFieldLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  letterSpacing: '0.08em',
  color: 'text.secondary',
  textTransform: 'uppercase',
};

export const toggleButtonBaseSx: SxProps<Theme> = {
  textTransform: 'none',
  fontSize: (theme) => theme.typography.pxToRem(13),
  fontWeight: 500,
  '&.Mui-selected': {
    color: 'common.white',
    backgroundColor: 'primary.main',
    '&:hover': {
      color: 'common.white',
      backgroundColor: 'primary.dark',
    },
  },
};
